
export const appName = "makeall";
export const tagLine = "Launch Your";
export const subTagLine = "With Ease!";